<template>
  <div class="wrapper app-content" v-loading="loading">
    <template v-if="!snapshot.isInitData">
      <div class="tilte-text"> 激活续费 </div>
      <div class="my-package">
        <div>
          <span class="version-span">您当前版本类型: <span>{{ snapshot.name }}</span></span>
          <span class="exp-span">有效期至: <span>{{ snapshot.effectTime }}（{{ getRestOfDay(snapshot.effectTime) }}）</span></span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="init-text"> 请先选择公众号主套餐 </div>
    </template>
    <div>
      <el-row :gutter="21" class="package-row" style="flex-wrap: wrap" type="flex">
        <el-col :span="6" v-if="!snapshot.isInitData" :lg="6" :xs="24" :sm="12" :md="8">
          <div class="package-box" style="background: #FFFBF7;border: 1px solid #FF8622;color: #FF8622;">
            <div class="package-div mine-package">
              <div class="package-top now-package-top">
                <div class="package-title">{{ snapshot.name }}</div>
                <div class="price-div"><span class="price-span">{{ snapshot.money }}</span>元/{{ snapshot.days }}天</div>
              </div>
              <div class="comm-box now-comm-box" style="">
                <div class="comm-div border-top-eee">利润分佣{{ snapshot.percent }}%</div>
                <img class="current-img" src="../../../../assets/img/official/dangqian.png" alt="">
              </div>
            </div>
          </div>
        </el-col>

        <template>
          <el-col v-for="(item, index) of packageList" :key="index" :span="6" :lg="6" :xs="24" :sm="12" :md="8">
            <div class="package-box">
              <div class="package-div">
                <div class="comm-box">
                  <div class="comm-div border-bottom-eee">
                    <div class="init-name package-title-text">
                      <div class="main-text">{{ getMainText(item.name) }}</div>
                      <div class="sub-text">{{ getSubText(item.name) }}</div>
                    </div>
                  </div>
                </div>

                <div class="spread-price sign-spread" v-if="item.sign">{{ item.sign }}</div>

                <div class="package-bottom">
                  <div class="price-div">
                    <span class="price-span">{{ getRMBFormate(item.money) }}</span>元/
                    <template v-if="item.type == 0">
                      <span>{{ item.days }}</span>天
                    </template>
                    <template v-else>
                      <span>{{ item.years }}</span>年
                    </template>
                  </div>
                  <div class="package-title">
                    <span class="package-init-text">利润分佣{{ item.percent }}%</span>
                  </div>
                  <div class="open-div">
                    <template v-if="!snapshot.isInitData">
                      <span class="open-btn" v-if="getDifferMoney(item.money) > 0">
                        <router-link tag="span" :to="item.linkPath" v-if="platformUuid != ''">
                          <a target="_blank" style="color:#fff;">补差升级套餐</a>
                        </router-link>
                        <span v-else @click="showTip()">补差升级套餐</span>
                      </span>
                      <span class="open-btn" v-else>
                        <router-link tag="span" :to="item.linkPath" v-if="platformUuid != ''">
                          <a target="_blank" style="color:#fff;">立即续费</a>
                        </router-link>
                        <span v-else @click="showTip()">立即续费</span>
                      </span>
                    </template>
                    <template v-else>
                      <span class="open-btn">
                        <router-link tag="span" :to="getLinkPath(item)">
                          <a target="_blank" style="color:#fff;">立即开通</a>
                        </router-link>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </template>
      </el-row>
      <div class="example-tip">
        基础版举例：小A关注了您的公众号，打开您的影票专属推广链接，通过竞价方式购买了2张电影票支付100元，扣除影票成本和技术服务费，订单剩余利润10元。订单放映2小时后结算，您获得70%的利润分佣，即70%*10元=7元。
      </div>
    </div>
    <div>
      <div class="part-item">
        <span class="part-item-title">高级进阶</span>
        <template v-if="!snapshot.isInitData">
          <span class="part-item-tip" v-if="snapshot.isProfit == 0">（开通分销功能，享受粉丝裂变高级功能）</span>
          <span class="part-item-tip" v-else>
            有效期至{{ snapshot.profitEffectTime ? snapshot.profitEffectTime : '暂无时间' }}
          </span>
        </template>
        <template v-else>
          <span class="part-item-tip">（开通分销功能，享受粉丝裂变高级功能）</span>
        </template>
      </div>
      <el-row :gutter="21" v-if="!isError">
        <el-col :span="6" :lg="6" :xs="24" :sm="12" :md="8">
          <div class="package-box">
            <div class="package-div">
              <div class="comm-box">
                <div class="comm-div border-bottom-eee">
                  <span class="init-name">{{ packageProfit.name }}</span>
                </div>
              </div>
              <div class="package-bottom">
                <div class="price-div"><span class="price-span">{{ packageProfit.money }}</span>元/{{ packageProfit.days }}天
                </div>
                <div class="package-title">
                  <span class="package-init-text">粉丝裂变高级功能</span>
                </div>
                <template v-if="!snapshot.isInitData">
                  <div class="open-div">
                    <span class="open-btn" v-if="snapshot.isProfit == 1">
                      <router-link tag="div" :to="linkPath" v-if="platformUuid != ''">
                        <a target="_blank" style="color:#fff;">
                          立即续费
                        </a>
                      </router-link>
                      <span v-else @click="showTip()">立即续费</span>
                    </span>
                    <span class="open-btn" v-else>
                      <router-link tag="div" :to="linkPath">
                        <a target="_blank" style="color:#fff;">
                          立即开通
                        </a>
                      </router-link>
                    </span>
                  </div>
                </template>
                <template v-else>
                  <div class="open-div">
                    <span class="open-btn" @click="showInfo({}, true)">立即开通</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="example-tip">
        分销功能举例：小A为您的公众号粉丝，其邀请了小B，小B又邀请了小C。小C打开您的影票专属推广链接，通过竞价方式购买了2张电影票100元，扣除影票成本和技术服务费，订单剩余利润10元。您获得70%的，即70%*10元=7元的总佣金。您需要支付给小B的推广佣金=您设置的一级推广佣金比例*10元，支付给小A的佣金=您设置的二级推广佣金比例*10元。剩下的就是您最终的推广利润。
      </div>
    </div>
    <div>
      <div class="part-item">
        <span class="part-item-title">版本对比</span>
      </div>
      <Table border :columns="columns" :data="list"></Table>
    </div>
    <activation-item ref="ActivationItem"></activation-item>
  </div>
</template>

<script>
import { getPlatformUuid, getUserUUID, getSnaphotId, getIsBasic } from '@/utils/auth'
import { Table, Icon } from 'view-design'
import checkRed from '@/assets/img/official/arrow_red.png'
import ActivationItem from '@/views/pc/official/activation/dialog/ActivationItem.vue'
import activation from '@/javaApi/activation'
import { Modal } from 'view-design'
const activationModel = new activation()
export default {
  name: "Activation",
  components: {
    Table,
    Icon,
    ActivationItem
  },
  data: function () {
    return {
      columns: [
        {
          title: '功能',
          key: 'fun'
        },
        {
          title: '基础版',
          key: 'basic',
          render: (h, params) => {
            let iconName = params.row.basic
            let renderData = []
            if (iconName) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: iconName,
                    width: 20
                  },
                })
              )
            }
            return renderData
          }
        },
        {
          title: '分销版',
          key: 'distribution',
          render: (h, params) => {
            let iconName = params.row.distribution
            let renderData = []
            if (iconName) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: iconName,
                    width: 20
                  },
                })
              )
            }
            return renderData
          }
        }
      ],
      isError: true,
      loading: true,
      list: [
        {
          'fun': '获取全国影院信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '获取最新影片信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '获取即将上映影片信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '秒出票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '特惠购票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '竞价购票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '绑定小程序',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '订单报表',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '推广素材库',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '用户裂变模块',
          'basic': '',
          'distribution': checkRed
        },
        {
          'fun': '自定义邀请海报',
          'basic': '',
          'distribution': checkRed
        },
        {
          'fun': '可设置分佣层级数，自定义分佣比例',
          'basic': '',
          'distribution': checkRed
        },
      ],
      packageList: [
      ],
      snapshot: {
        name: '暂无套餐',
        effectTime: '0000-00-00',
        money: 0,
        isInitData: true
      },
      packageProfit: {},
      linkPath: {
        path: '/pc/pay/list',
        query: {
          platformUuid: getPlatformUuid(),
          isProfit: 1,
          packageId: 0,
          type: 4,
          snapshotId: 0
        }
      },
      jsonObject: {

      },
      platformUuid: getPlatformUuid()
    }
  },
  created() {
    this.getPackageList()
  },
  methods: {
    getPackageList() {
      let queryParam = this.$route.query
      let nowSnapshotId = getSnaphotId() ? (getSnaphotId() == 'null') ? 0 : getSnaphotId() : 0
      let addPub = (queryParam.isNew) ? true : false
      if (nowSnapshotId == -1) {
        addPub = true
      }
      if (nowSnapshotId == -1) {
        nowSnapshotId = 0
      }
      let param = {
        openUserUuid: getUserUUID() ? getUserUUID() : '',
        addPub: addPub,
        snapshotId: nowSnapshotId
      }
      let platformUuid = getPlatformUuid();
      let condition = (platformUuid == '' || platformUuid == 0);
      if (!condition) {
        param.platformUuid = platformUuid
      }
      let that = this
      activationModel.getPackageList(param).then(response => {
        that.loading = false
        let res = response.data
        if (res.code === 200) {
          if (res.data) {
            if (res.data.list) {
              this.isError = false
              that.packageList = res.data.list
              if (res.data.snapshot) {
                this.linkPath.query.snapshotId = res.data.snapshot.id
              }
              if (that.packageList.length > 0) {
                let i = 0;
                for (i; i < that.packageList.length; i++) {
                  //   let currentMoney =   parseFloat(money)
                  let snapshotMoney = 0
                  let templateSnapshotId = 0
                  if (res.data.snapshot) {
                    snapshotMoney = parseFloat(res.data.snapshot.money)
                    this.linkPath.query.snapshotId = res.data.snapshot.id
                    templateSnapshotId = res.data.snapshot.id
                  }
                  let money = that.packageList[i]['money']
                  if ((snapshotMoney - money) == 0) {
                    that.packageList[i]['linkPath'] = {
                      path: '/pc/pay/list',
                      query: {
                        platformUuid: getPlatformUuid(),
                        packageId: that.packageList[i]['id'],
                        type: 3,
                        snapshotId: templateSnapshotId
                      }
                    }
                  } else {
                    // 是否过期了 过期就调用立刻续费的接口
                    let now = this.$moment()
                    let timeDiff = -1
                    if (res.data.snapshot) {
                      let effectTime = this.$moment(res.data.snapshot.effectTimeStr)
                      timeDiff = effectTime.diff(now)
                    }
                    if (timeDiff >= 0) {
                      // 补差升级的url
                      that.packageList[i]['linkPath'] = {
                        path: '/pc/pay/list',
                        query: {
                          platformUuid: getPlatformUuid(),
                          isProfit: 0,
                          packageId: that.packageList[i]['id'],
                          type: 1,
                          snapshotId: templateSnapshotId
                        }
                      }
                    } else {
                      // 立刻续费的url
                      that.packageList[i]['linkPath'] = {
                        path: '/pc/pay/list',
                        query: {
                          platformUuid: getPlatformUuid(),
                          packageId: that.packageList[i]['id'],
                          type: 3,
                          snapshotId: templateSnapshotId
                        }
                      }
                    }
                  }

                }
              }
            }

            if (res.data.snapshot) {
              that.snapshot = res.data.snapshot
            }
            if (res.data.packageProfit) {
              that.packageProfit = res.data.packageProfit
              that.linkPath.query.packageId = res.data.packageProfit.id
            }

          }

        } else {
          let message = res.message ? res.message : '系统异常请稍后再试！'
          that.$message.error(message)
        }
      }).catch(error => {
        if (error != 'token invalid') {
          that.$message.error('系统异常请稍后再试！')
        }
        that.loading = false
      })
    },
    showInfo: function (item, isProfit) {
      if (this.packageList && this.packageList.length == 0) {
        this.$message.info('暂无基础套餐！请联系网站管理员添加对应的套餐再点击开通分销套餐！')
        return
      }
      let condition = JSON.stringify(item) == "{}";
      if (condition) {
        item = (this.packageList) ? this.packageList[0] : []
      }
      let isProfitInt = Number(isProfit)
      isProfitInt = isProfitInt ? isProfitInt : 0
      this.$refs.ActivationItem.init(this.packageList, item, isProfitInt, this.packageProfit)
    },
    getRMBFormate(money) {
      return parseFloat(money).toFixed(2)
    },
    getLinkPath(item) {
      let query = {
        isProfit: 0,
        packageId: item.id,
        type: 2
      }
      let templatePlatformUuid = getPlatformUuid()
      let condition = (templatePlatformUuid == '' || templatePlatformUuid == 0);
      if (!condition) {
        query.templatePlatformUuid = templatePlatformUuid
      }
      return {
        path: '/pc/pay/list',
        query: query
      }
    },
    getDifferMoney(money) {
      let currentMoney = parseFloat(money) ? parseFloat(money) : 0
      let snapshotMoney = parseFloat(this.snapshot.money) ? parseFloat(this.snapshot.money) : 0
      return (currentMoney - snapshotMoney).toFixed(2)
    },
    getRestOfDay(createTime) {
      let _d_tm = new Date(new Date().valueOf());
      let _d_now = new Date(new Date().valueOf());
      if (createTime) {
        _d_now = new Date((createTime).replace(/-/g, "/"));
      }
      if (_d_now < _d_tm) {
        return '已过期'
      }
      let leftTime = ~~((_d_now - _d_tm) / 1000 / 60 / 60 / 24);
      return leftTime + '天'
    },
    getMainText(item) {
      return item.substr(0, 8)
    },
    getSubText(item) {
      let lastLen = (item.length >= 32) ? 32 : item.length
      return item.substr(8, lastLen)
    },
    showTip() {
      let that = this
      Modal.warning({
        title: '提示',
        content: '请先去绑定公众号',
        onOk: function () {
          if (getIsBasic() === 'true') {
            that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 4)
          } else {
            that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 7)
          }
          that.$router.push('/pc/official/authorization').catch(err => { err })
        }
      })
    }
  }
}
</script>

<style scoped>
>>>.el-row--flex {
  flex-wrap: wrap !important;
}
</style>
<style>
.package-row .el-col {
  margin-bottom: 30px;
}

.border-top-eee {
  border-top: 1px solid #EEEEEE;
}

.border-bottom-eee {
  border-bottom: 1px solid #EEEEEE;
}

.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .init-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
  padding-bottom: 40px;
}

.wrapper .my-package {
  background: #FAFAFA;
  border-radius: 4px;
  padding: 19px 20px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #999999;
  margin: 10px 0 35px 0;
}

.wrapper .my-package .version-span {
  padding-right: 20px;
}

.wrapper .my-package .version-span span {
  color: #222222;
  padding-left: 5px;
}

.wrapper .my-package .exp-span {
  padding-left: 20px
}

.wrapper .my-package .exp-span span {
  color: #3D9EFC;
  padding-left: 5px;
}

.wrapper .package-box {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  color: #222222;
  text-align: center;
  font-family: Alibaba-PuHuiTi-M;
  border-radius: 4px;
  font-size: 24px;
  height: 100%;
}

.wrapper .package-div {
  /* padding: 0 20px; */
  color: #222222;
  position: relative;
  cursor: pointer;
  height: 100%;
}

.wrapper .package-div.mine-package {
  min-height: 309px;
}

@media screen and (max-width: 768px) {
  .wrapper .package-div.mine-package {
    min-height: 209px;
  }
}

.wrapper .package-div .package-top {
  padding: 40px 20px 0 20px
}

.wrapper .package-div .now-package-top {
  font-family: Alibaba-PuHuiTi-M;
  color: #FF8622;
  padding: 0 !important;
  position: absolute;
  top: calc(50% - 55px);
  width: 100%;
}

.wrapper .package-div .now-package-top .package-title {
  padding: 0 20px;
}

.wrapper .package-div .package-top .buy-package-btn {
  margin-top: 20px;
  color: #FFFFFF;
  background: #FF8622;
  border-radius: 1px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}

.wrapper .package-div .package-top .buy-package-btn span {
  width: 100%;
  display: inline-block;
}

.wrapper .package-div .package-top .buy-package-btn span a {
  width: 100%;
  display: inline-block;
}

.wrapper .package-div .package-bottom {
  padding: 30px 20px;
}

.wrapper .package-div .package-title {
  font-size: 18px;
  word-break: break-all;
}

.wrapper .package-div .package-title.user-choose-data {
  height: 91px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.wrapper .package-div .package-title .main-text {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 24px;
  color: #666666;
  word-break: break-all;
}

.wrapper .package-div .package-title .sub-text {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #999999;
  word-break: break-all;
  line-height: 24px;
}

.wrapper .package-div .package-init-text {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 18px;
  color: #999999;
}

.wrapper .package-div .price-div {
  font-size: 12px;
}

.wrapper .package-div .price-div .price-span {
  font-size: 26px;
  line-height: 44px;
}

.wrapper .package-div .comm-box {
  padding: 0 20px;
}

.wrapper .package-div .comm-box.now-comm-box {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #FF8622;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.wrapper .package-div .comm-box .comm-div {
  font-size: 16px;
  line-height: 40px;
}

.wrapper .package-div .comm-box .comm-div .init-name {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 20px;
  color: #666666;
  display: flex;
  padding: 15px 0;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  height: 115px;
  overflow: hidden;
}

.wrapper .package-div .comm-box .comm-div .init-name.package-title-text {
  flex-wrap: wrap;
}

.wrapper .package-div .comm-box .comm-div .init-name.package-title-text .main-text {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 20px;
  color: #222222;
  word-break: break-all;
}

.wrapper .package-div .comm-box .comm-div .init-name.package-title-text .sub-text {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #999999;
  word-break: break-all;
  line-height: 24px;
}

.wrapper .package-div .current-img {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 78px;
}

.wrapper .package-div .spread-price {
  position: absolute;
  top: -15px;
  left: -1px;
  background: #FF4F76;
  border-radius: 4px 0 4px 0;
  color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  padding: 0 10px;
}

.wrapper .package-div .spread-price.sign-spread {
  position: absolute;
  top: 0;
  left: 0;
  background: #FF4F76;
  border-radius: 4px 0 4px 0;
  color: #FFFFFF;
  height: 18px;
  line-height: 18px;
  font-size: 13px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.wrapper .example-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #999999;
  padding-top: 10px;
  line-height: 22px;
}

.wrapper .part-item {
  font-size: 20px;
  line-height: 27px;
  padding: 20px 0;
}

.wrapper .part-item .part-item-title {
  font-family: Alibaba-PuHuiTi-M;
  color: #222222;
}

.wrapper .part-item .part-item-tip {
  font-family: Alibaba-PuHuiTi-R;
  color: #999999;
}

.wrapper .open-div {
  margin: 25px 0 5px;
}

.wrapper .open-div .open-btn {
  display: block;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 18px;
  background: #FF8622;
  border-radius: 2px;
  color: #FFFFFF;
  padding: 3px 0;
}

.wrapper .open-div .open-btn span {
  width: 100%;
  display: inline-block;
}

.wrapper .open-div .open-btn span a {
  width: 100%;
  display: inline-block;
}

.wrapper .open-div .open-btn div {
  width: 100%;
}

.wrapper .open-div .open-btn div a {
  width: 100%;
  display: inline-block;
}

.ivu-table td,
.ivu-table th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/activation/Index.vue